import Navbar from "../components/navbar/navbar";

import Footer from "./../components/footer/footer";

import Industries from "./../components/industrycomponents/industries";

import Header from "./../components/industrycomponents/header";

import Industries1 from "./../components/industrycomponents/industry1";

import Newsletter from "./../components/homecomponents/newsletter5";

import Description from "./../components/industrycomponents/description";

const Industry = () => {
    return(
        <div>
            <Navbar/>
            <Header/>
            <Industries/>
            <Industries1/>
            <Description/>
            <Newsletter/>
            <Footer />
        </div>
    )
}
export default Industry;